/* portfolio.js — g-weil.com | Guillermo Weil */

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation";

const splashScreen = {
  enabled: true,
  animation: splashAnimation,
  duration: 2000
};

const illustration = {
  animated: true
};

const greeting = {
  username: "g-weil",
  title: "Hola, soy Guillermo",
  subTitle: emoji(
    "Desarrollador Full-Stack 🚀 especializado en plataformas web premium, sistemas SaaS, aplicaciones móviles Android y soluciones digitales que impulsan negocios reales."
  ),
  resumeLink: "",
  displayGreeting: true
};

const socialMediaLinks = {
  gmail: "weilguillermo@gmail.com",
  whatsapp: "+34684689580",
  whatsapp2: "+34675987602",
  display: true
};

const skillsSection = {
  title: "¿Qué hago?",
  subTitle: "DESARROLLO SOLUCIONES DIGITALES COMPLETAS — DEL DISEÑO AL SERVIDOR EN PRODUCCIÓN",
  skills: [
    emoji("⚡ Plataformas web premium responsive con React, Vue y PHP"),
    emoji("⚡ Sistemas SaaS de gestión y reparto con Node.js y MongoDB"),
    emoji("⚡ Aplicaciones Android nativas publicadas en Google Play"),
    emoji("⚡ Paneles de administración, APIs REST y despliegue en VPS Linux")
  ],
  softwareSkills: [
    { skillName: "HTML5",       fontAwesomeClassname: "fab fa-html5" },
    { skillName: "CSS3",        fontAwesomeClassname: "fab fa-css3-alt" },
    { skillName: "JavaScript",  fontAwesomeClassname: "fab fa-js" },
    { skillName: "React",       fontAwesomeClassname: "fab fa-react" },
    { skillName: "Node.js",     fontAwesomeClassname: "fab fa-node" },
    { skillName: "PHP",         fontAwesomeClassname: "fab fa-php" },
    { skillName: "Android",     fontAwesomeClassname: "fab fa-android" },
    { skillName: "MongoDB",     fontAwesomeClassname: "fas fa-database" },
    { skillName: "Docker",      fontAwesomeClassname: "fab fa-docker" },
    { skillName: "Linux",       fontAwesomeClassname: "fab fa-linux" },
    { skillName: "Git",         fontAwesomeClassname: "fab fa-git-alt" },
    { skillName: "npm",         fontAwesomeClassname: "fab fa-npm" }
  ],
  display: true
};

const educationInfo = {
  display: false
};

const techStack = {
  viewSkillBars: true,
  experience: [
    { Stack: "Frontend / UI",    progressPercentage: "90%" },
    { Stack: "Backend / APIs",   progressPercentage: "85%" },
    { Stack: "Mobile / Android", progressPercentage: "75%" }
  ],
  displayCodersrank: false
};

const workExperiences = {
  display: true,
  experience: [
    {
      role: "Desarrollador Full-Stack & Fundador",
      company: "g-weil.com",
      companylogo: require("./assets/images/projects/sportico.png"),
      date: "2022 – Presente",
      desc: "Diseño, desarrollo y despliegue de plataformas web, sistemas SaaS y apps Android para clientes en España y Latinoamérica.",
      descBullets: [
        "Sistemas de gestión de reparto y logística en producción",
        "Apps Android publicadas en Google Play Store",
        "Plataformas web premium para restaurantes, inmobiliarias y barbería"
      ]
    }
  ]
};

const openSource = {
  showGithubProfile: "false",
  display: false
};

const bigProjects = {
  title: "Proyectos",
  subtitle: "SOLUCIONES REALES DESARROLLADAS Y EN PRODUCCIÓN",
  projects: [
    {
      image: require("./assets/images/projects/transportesfrade.png"),
      projectName: "Transportes Frade",
      projectDesc: "Plataforma web para empresa de transporte en Gijón: mudanzas, portes, retirada de escombros y transporte de vehículos. Diseño profesional adaptado para captar clientes locales y nacionales.",
      footerLink: [{ name: "Ver sitio", url: "https://transportesfrade.com/" }]
    },
    {
      image: require("./assets/images/projects/transportevillalba.png"),
      projectName: "Transportes Villalba",
      projectDesc: "Sistema web para empresa de paquetería y logística en Asturias. Incluye seguimiento en tiempo real, gestión de rutas y panel de clientes.",
      footerLink: [{ name: "Ver sitio", url: "https://transportevillalba.com/" }]
    },
    {
      image: require("./assets/images/projects/sportico.png"),
      projectName: "Sportico",
      projectDesc: "Plataforma SaaS de análisis deportivo con pronósticos basados en estadísticas avanzadas. Motor de predicción, dashboard interactivo y panel de administración.",
      footerLink: [{ name: "Ver plataforma", url: "https://sportico.g-weil.com/" }]
    },
    {
      image: require("./assets/images/projects/inmobiliaria.png"),
      projectName: "Velaré Estates",
      projectDesc: "Portal inmobiliario boutique de lujo con narrativa visual premium. Presentación de propiedades de alto nivel con galería inmersiva, curaduría global y experiencia de usuario de primera clase.",
      footerLink: []
    },
    {
      image: require("./assets/images/projects/restaurante.png"),
      projectName: "Restaurante Digital",
      projectDesc: "Web completa para restaurante con sistema integrado de pedidos online, gestión de reparto a domicilio, carta digital interactiva y panel de administración en tiempo real.",
      footerLink: []
    },
    {
      image: require("./assets/images/projects/barberia.png"),
      projectName: "Barbería Vintage",
      projectDesc: "Web premium estilo vintage para barbería con sistema de reservas por turnos, selección de barbero, galería lightbox, precios detallados y reseñas de clientes.",
      footerLink: []
    }
  ],
  display: true
};

const achievementSection = { display: false };
const blogSection        = { display: false };
const talkSection        = { display: false };
const podcastSection     = { display: false };
const resumeSection      = { display: false };

const contactInfo = {
  title: emoji("Hablemos 💬"),
  subtitle: "¿Tienes un proyecto en mente? Escríbeme y lo hacemos realidad.",
  number: "+34 675 987 602",
  number2: "+34 684 689 580",
  email_address: "weilguillermo@gmail.com"
};

const twitterDetails = {
  userName: "",
  display: false
};

const isHireable = true;

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
